import { theme } from '@theme';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Typography } from '../../../style';

type FiltersHeaderProps = {
  contentSpacingType?: string;
  contentSpacing?: number;
  children?: ReactNode;
};

const FiltersHeader: FC<FiltersHeaderProps> = (props) => {
  return (
    <Wrapper data-testid='filters-header' contentSpacingType={props.contentSpacingType}>
      <Typography
        theme={theme}
        size={theme.typography.h3}
        fontWeight={theme.typography.fontWeights.semibold}
        marginRight={
          props.contentSpacingType && props.contentSpacingType == 'flex-start'
            ? props.contentSpacing
            : 0
        }
      >
        Filters
      </Typography>
      {props.children}
    </Wrapper>
  );
};

export default FiltersHeader;

const Wrapper = styled.div.attrs<FiltersHeaderProps>({}) <FiltersHeaderProps>`
  position: relative;
  display: flex;
  justify-content: ${(props) => props.contentSpacingType ?? 'space-between'};
  align-items: center;
  padding-top: 0px;
  width: 100%;
  margin-bottom: 10px;
  & span:nth-child(2) {
    cursor: pointer;
  }
`;
